var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "taC mc15" }, [
      _vm.photoData
        ? _c("img", {
            staticClass: "offer-img-main image-height-auto",
            attrs: {
              src: _vm.getPhotoUrl(_vm.photoData),
              alt: _vm.companyName,
            },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("p", {
      staticClass: "-caption pega-pre-wrap",
      domProps: { textContent: _vm._s(_vm.caption) },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "contents-inner" },
      [
        _c(
          "div",
          {
            staticClass: "bg-stripe-type01 text-block",
            style:
              "background: url(" +
              _vm.userCommonImageUrlForSp +
              "/bg_stripe_red.png) repeat left;",
          },
          [
            _c("p", {
              staticClass: "fwB pega-pre-wrap",
              attrs: { "data-test": "title" },
              domProps: { textContent: _vm._s(_vm.title) },
            }),
          ]
        ),
        _vm._v(" "),
        _c("p", {
          staticClass: "text-block pega-pre-wrap",
          attrs: { "data-test": "body" },
          domProps: { textContent: _vm._s(_vm.body) },
        }),
        _vm._v(" "),
        _c("hr", { staticClass: "hr-type-01" }),
        _vm._v(" "),
        _c("job-appeal-point-sp", {
          attrs: { "pr-codes": _vm.prCodes, "is-search-result": true },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }